import React, { useState, useEffect } from 'react';
import {
  InputNumber,
  Input,
  Button,
  Select, Divider,
  Space,
  Modal,
  message
} from 'antd';
import {
  CloseOutlined,
  PlusCircleOutlined,
  SaveOutlined
} from '@ant-design/icons';
import './style';
import { default as GoodsNew } from './goodsNew';
import { Page } from '../../components';
import {
  insert,
  getList
} from '../../services/Goods';

export default React.forwardRef((props, ref) => {
  const { rows, goodsSizeCol, goodsSpecCol, goodsWeightCol, onCloseCallback, onSaveCallback } = props;
  const [isShowNew, setShowNew] = useState(false);
  const [goods, setGoods] = useState(rows.filter(x => x._selected).map(x => ({ 
    ...x, goods_id: undefined, size: undefined, weight: undefined, name: x[goodsSpecCol]
  })));
  const [goodsList, setGoodsList] = useState([]);
  useEffect(() => {
    getList().then(data => setGoodsList(data));
  }, []);

  const onNewCallback = async (goods) => {
    try {
      const key = 'create_goods';
      console.log('onNewCallback:', goods);
      message.loading({ content: '正在新建产品...', key });
      insert(goods).then(() => {
        getList().then(data => {
          setGoodsList(data);
          setShowNew(false);
          message.success({ content: `新建产品成功 [#${goods.name_en}]`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSave = async () => {
    const values = goods.filter(x => x.goods_id && x.size).map(x=> ({
      idx: x._idx,
      goods_id: x.goods_id,
      size: x.size,
      weight: x.weight,
      name: x.name
    }))
    if (values.length === 0) {
      Modal.error({
        title: '未选择产品名',
        content: '请选择有效产品名或者尺寸！',
      });
      return;
    }
    try {
      if (onSaveCallback) {
        onSaveCallback(values, onClose);
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onChangeWeight = (i, v) => {
    const temp = [].concat(goods);
    temp[i].weight = v;
    setGoods(temp);
  }
  const onChangeSize = (i, v) => {
    const temp = [].concat(goods);
    temp[i].size = v;
    setGoods(temp);
  }

  const onChangeName = (i, v) => {
    const temp = [].concat(goods);
    temp[i].goods_id = v;
    setGoods(temp);
  }

  return (
    <div style={{ padding: '1rem 1rem' }}  >
      <table border="1">
        <thead>
          <th width="140px">产品号</th>
          <th width="120px">单重</th>
          <th width="120px">尺寸<span style={{ color: 'red' }}> (*)</span></th>
          <th width="640px">产品名称<span style={{ color: 'red' }}> (*)</span></th>
        </thead>
        <tbody>
          {
            goods.map((y, i) => {
              return <tr>
                <td>{y[goodsSpecCol]}</td>
                <td>{y[goodsWeightCol] ? y[goodsWeightCol] : <InputNumber style={{ width: '100%' }} onChange={(e) => onChangeWeight(i, e)} min={1} max={999999} size="small"></InputNumber>}</td>
                <td>{y[goodsSizeCol] ? y[goodsSizeCol] : <Input style={{ width: '100%' }} onChange={(e) => onChangeSize(i, e.target.value)} size="small"></Input>}</td>
                <td>
                  <div style={{ display: 'flex' }}>
                    <Select
                      showSearch
                      placeholder="请选择产品名称"
                      optionFilterProp="children"
                      style={{ width: '100%' }}
                      onChange={(e) => onChangeName(i, e)}
                      size="small">
                      {
                        goodsList.map(x => {
                          return <Select.Option key={x.id} value={x.id}>
                            {x.name_en}
                          </Select.Option>
                        })
                      }
                    </Select>
                    <Button size="small" type="primary" onClick={() => setShowNew(true)} icon={<PlusCircleOutlined />}>添加新产品</Button>
                  </div>
                </td>
              </tr>
            })
          }
        </tbody>
      </table>
      <Divider />
      <div className="page-footer">
        <div></div>
        <Space size="large">
          <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>
          <Button onClick={onSave} type="primary" icon={<SaveOutlined />}>保 存</Button>
        </Space>
      </div>
      <Page
        width="720px"
        title="新建产品"
        onCloseCallback={() => setShowNew(false)}
        body={<GoodsNew mode="new" onSaveCallback={onNewCallback} onCloseCallback={() => setShowNew(false)} />}
        visible={isShowNew} />
    </div>)
});
